var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08301 3.33594H2.99967C2.55765 3.33594 2.13372 3.51153 1.82116 3.82409C1.5086 4.13665 1.33301 4.56058 1.33301 5.0026V16.6693C1.33301 17.1113 1.5086 17.5352 1.82116 17.8478C2.13372 18.1603 2.55765 18.3359 2.99967 18.3359H7.99967M10.9163 3.33594H12.9997C13.4417 3.33594 13.8656 3.51153 14.1782 3.82409C14.4907 4.13665 14.6663 4.56058 14.6663 5.0026V12.5026",
    stroke: "#5B5B5B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66602 5.33594V3.7526C4.66602 3.6421 4.70991 3.53612 4.78805 3.45798C4.86619 3.37984 4.97218 3.33594 5.08268 3.33594C5.31268 3.33594 5.50268 3.14927 5.54268 2.9226C5.66602 2.2126 6.14435 0.835938 7.99935 0.835938C9.85435 0.835938 10.3327 2.2126 10.456 2.9226C10.496 3.14927 10.686 3.33594 10.916 3.33594C11.0265 3.33594 11.1325 3.37984 11.2106 3.45798C11.2888 3.53612 11.3327 3.6421 11.3327 3.7526V5.33594C11.3327 5.46855 11.28 5.59572 11.1862 5.68949C11.0925 5.78326 10.9653 5.83594 10.8327 5.83594H5.16602C5.03341 5.83594 4.90623 5.78326 4.81246 5.68949C4.71869 5.59572 4.66602 5.46855 4.66602 5.33594V5.33594Z",
    stroke: "#5B5B5B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.916 17.0859L12.5827 18.7526L16.7493 14.5859",
    stroke: "#5B5B5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCheck);
export default __webpack_public_path__ + "static/media/statusCheck.8a14f30b3b30308ff3c4f51d28f84981.svg";
export { ForwardRef as ReactComponent };